<template>
    <div class="dayiView">
        <!--列表渲染-->
        <div class="dayiBox">
            <div
                class="dayiList"
                v-for="(item,index) in dayiList" 
                :key="index"
                @click="dayiListClick(item,index)">
                <p>
                    <span class="buleSpan">{{ (index + 1) + (page - 1) * size }}</span>
                    <span>.</span>
                    <span v-html="item.title"></span>
                </p>
                <p class="dayiListTime">{{ item.publishDate }}</p>
            </div>
        </div>
        <!--分页-->
        <div class="fenyeBox">
            <el-pagination
                @current-change="handleCurrentChange"
                :current-page.sync="page"
                :page-size="this.size"
                layout="total, prev, pager, next,jumper"
                :total="total"
              >
            </el-pagination>
        </div>
    </div>
</template>
<script>
import {
    cmsDataGetTagNames,
    getDaYiData,
} from '@/api/importZSG/api'
export default {
    name:'',
    props:['sendData'],
    data(){
        return{
            loading:null,
            texts:'',
            dayiList:[],
            total:0,
            page:1,
            size:10,
        }
    },
    mounted(){
        console.log(this.$props.sendData)
        //获取数据
        this.getDyDataFN();
    },
    methods:{
        getDyDataFN(){
            this.loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            //先获取tagName
            this.getTagNames()
        },
        //获取tagName
        getTagNames(){
            let data = {
                tagIds: this.$props.sendData.tagIds,
                //Content: {"tagIds":"6557332"}
            }
            cmsDataGetTagNames(data).then(res => {
                //console.log(res)
                this.page = 1;
                this.total = 0;
                let getArr = res.data.data
                this.texts = getArr.join(' ')
                //获取答疑数据
                this.getDYSearch()
            })
        },
        //获取答疑数据
        getDYSearch(){
            let data = {
                keyword:this.texts,
                page:this.page,
                size:10,
                tagIds:[],
                year:'',
            //keywordExact:''
            }
            getDaYiData(data).then(res => {
                this.dayiList = res.data.rows
                this.total = res.data.total
                this.emitParent()
                //console.log(this.dayiList)
                this.loading.close()
            })
        },
        //回传的数据
        emitParent(){
            this.$emit('sendTotal',{total:this.total})
        },
        //分页发生改变
        handleCurrentChange(v) {
            this.loading = this.$loading({
                lock: true,
                text: '拼命加载中',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)',
            })
            this.page = v
            this.getDYSearch()
        },
        //答疑数据详情
        dayiListClick(item,index){
            console.log(item);
            //this.$message('详情')
            let Detail = this.$router.resolve({
                path: '/content',
                query: {
                    contentId: item.id,
                    keyWord: this.texts,
                },
            })
             window.open(Detail.href, '_blank')
        }
    }
}
</script>
<style scoped lang="scss">
.dayiView{
    background: #fff;
}
.dayiBox{
    box-sizing: border-box;
    padding:0 20px;
    overflow: hidden;
    .dayiList{
        font-size: 16px!important;
        color:#3D3D3D;
        line-height: 32px;
        cursor:pointer;
        box-sizing: border-box;
        padding-bottom:20px;
        border-bottom:1px solid #D8D8D8;
        margin-top:20px;
        .dayiListTime{
            width: 100%;
            height: 40px;
            line-height: 40px;
            background: #F5F5F5;
            box-sizing: border-box;
            padding-left:18px;
            font-weight: 400;
            font-size: 14px;
            color: #003FA8;
            margin-top:20px;
        }
        .buleSpan{
            color:#003FA8;
        }
    }
}

.fenyeBox{
    background: #fff;
    text-align: center;
    padding:10px 0;
}
</style>